import { module } from 'angular';
import { gmcEmailValidatorDirective, gmcPhoneValidatorDirective } from './index';

export const ValidatorDirectivesModule = module('app.shared.directives.validators', [])
  .directive('gmcPhoneValidator', gmcPhoneValidatorDirective)
  .directive('gmcEmailValidator', gmcEmailValidatorDirective);



// WEBPACK FOOTER //
// ./app/shared/directives/validator-directives/validator-directives.module.ts